var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('transition',{attrs:{"name":"page-transition"}},[_c('view-layout')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }